import React from 'react';
import { Link } from 'react-router-dom';

const TermsConditions = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1>Terms & Conditions</h1>
        <p className="last-updated">Last Updated: February 2026</p>

        <section className="terms-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using TravelFamily's website and services, you agree to be bound by these Terms and Conditions. 
            If you do not agree with any part of these terms, please do not use our services.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Services Provided</h2>
          <p>
            TravelFamily provides international travel consultation, booking assistance, and holiday package services for families. 
            Our services include but are not limited to:
          </p>
          <ul>
            <li>Travel consultation and itinerary planning</li>
            <li>Flight and hotel booking assistance</li>
            <li>Destination recommendations and guidance</li>
            <li>Tour package arrangements</li>
            <li>Travel documentation support</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>3. Booking and Payments</h2>
          <p>
            All bookings made through TravelFamily are subject to the following conditions:
          </p>
          <ul>
            <li>Full payment is required at the time of booking confirmation</li>
            <li>All bookings are non-refundable unless otherwise specified</li>
            <li>Prices are subject to change based on availability and seasonality</li>
            <li>Additional charges may apply for last-minute bookings or modifications</li>
            <li>Payment can be made through approved payment methods only</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>4. Cancellation and Refund Policy</h2>
          <p>
            Cancellations must be made in writing and are subject to the following terms:
          </p>
          <ul>
            <li>Cancellations made 30+ days before departure: 25% cancellation fee</li>
            <li>Cancellations made 15-29 days before departure: 50% cancellation fee</li>
            <li>Cancellations made less than 15 days before departure: No refund</li>
            <li>No-shows: No refund applicable</li>
            <li>Refunds will be processed within 30 business days</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>5. Travel Documentation</h2>
          <p>
            It is the traveler's responsibility to ensure all travel documents are valid and up-to-date:
          </p>
          <ul>
            <li>Valid passport (minimum 6 months validity from travel date)</li>
            <li>Appropriate visas for destination countries</li>
            <li>Travel insurance (highly recommended)</li>
            <li>Health certificates and vaccination records if required</li>
          </ul>
          <p>
            TravelFamily is not responsible for any issues arising from invalid or incomplete travel documentation.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. Travel Insurance</h2>
          <p>
            We strongly recommend all travelers purchase comprehensive travel insurance covering:
          </p>
          <ul>
            <li>Trip cancellation and interruption</li>
            <li>Medical emergencies and evacuation</li>
            <li>Lost or delayed baggage</li>
            <li>Flight delays and cancellations</li>
          </ul>
          <p>
            TravelFamily is not liable for costs incurred due to lack of travel insurance.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. Liability and Disclaimer</h2>
          <p>
            TravelFamily acts as an intermediary between travelers and service providers (airlines, hotels, tour operators). 
            We are not liable for:
          </p>
          <ul>
            <li>Acts of God, natural disasters, or force majeure events</li>
            <li>Political unrest, strikes, or civil disturbances</li>
            <li>Cancellations or changes by airlines, hotels, or other service providers</li>
            <li>Personal injury, illness, or death during travel</li>
            <li>Loss or damage to personal belongings</li>
            <li>Delays, rescheduling, or overbooking by service providers</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>8. Health and Safety</h2>
          <p>
            Travelers must ensure they are fit to travel and comply with all health and safety requirements:
          </p>
          <ul>
            <li>Disclose any medical conditions that may affect travel</li>
            <li>Follow destination-specific health advisories</li>
            <li>Maintain appropriate travel insurance for medical emergencies</li>
            <li>Comply with local laws and regulations at all destinations</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>9. Itinerary Changes</h2>
          <p>
            TravelFamily reserves the right to modify itineraries due to unforeseen circumstances. 
            We will make reasonable efforts to provide comparable alternatives. Changes may occur due to:
          </p>
          <ul>
            <li>Weather conditions</li>
            <li>Safety concerns</li>
            <li>Service provider changes</li>
            <li>Government restrictions or advisories</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>10. Customer Conduct</h2>
          <p>
            Travelers are expected to:
          </p>
          <ul>
            <li>Behave respectfully towards other travelers, guides, and locals</li>
            <li>Follow instructions from tour guides and coordinators</li>
            <li>Respect local customs, traditions, and laws</li>
            <li>Not engage in illegal activities</li>
          </ul>
          <p>
            TravelFamily reserves the right to terminate services for travelers who violate these conduct expectations.
          </p>
        </section>

        <section className="terms-section">
          <h2>11. Privacy and Data Protection</h2>
          <p>
            We collect and process personal information in accordance with applicable data protection laws. 
            Your information is used solely for:
          </p>
          <ul>
            <li>Processing bookings and payments</li>
            <li>Communicating travel information</li>
            <li>Providing customer support</li>
            <li>Sending promotional materials (with consent)</li>
          </ul>
          <p>
            We do not sell or share your personal information with third parties except as necessary to provide our services.
          </p>
        </section>

        <section className="terms-section">
          <h2>12. Intellectual Property</h2>
          <p>
            All content on TravelFamily's website, including text, images, logos, and designs, is protected by copyright 
            and intellectual property laws. Unauthorized use or reproduction is prohibited.
          </p>
        </section>

        <section className="terms-section">
          <h2>13. Dispute Resolution</h2>
          <p>
            Any disputes arising from these Terms and Conditions will be resolved through:
          </p>
          <ul>
            <li>Initial attempt at amicable resolution through customer support</li>
            <li>Mediation if direct resolution fails</li>
            <li>Arbitration under the laws of [Your Jurisdiction]</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>14. Governing Law</h2>
          <p>
            These Terms and Conditions are governed by the laws of India. Any legal proceedings will be conducted 
            in the courts of Mumbai, Maharashtra.
          </p>
        </section>

        <section className="terms-section">
          <h2>15. Contact Information</h2>
          <p>
            For questions or concerns regarding these Terms and Conditions, please contact us:
          </p>
          <ul>
            <li>Email: legal@travelfamily.com</li>
            <li>Phone: +91 98765 43210</li>
            <li>Address: 123 Travel Street, Mumbai, India</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>16. Changes to Terms</h2>
          <p>
            TravelFamily reserves the right to modify these Terms and Conditions at any time. 
            Updated terms will be posted on our website with a revised "Last Updated" date. 
            Continued use of our services after changes constitutes acceptance of the modified terms.
          </p>
        </section>

        <div className="terms-footer">
          <p>
            By using TravelFamily's services, you acknowledge that you have read, understood, 
            and agree to be bound by these Terms and Conditions.
          </p>
          <Link to="/" className="back-link-bottom">Return to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
